import { render, staticRenderFns } from "./AdminNextIframe.vue?vue&type=template&id=184afb93&scoped=true"
import script from "./AdminNextIframe.vue?vue&type=script&lang=js"
export * from "./AdminNextIframe.vue?vue&type=script&lang=js"
import style0 from "./AdminNextIframe.vue?vue&type=style&index=0&id=184afb93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184afb93",
  null
  
)

export default component.exports